import { Tooltip } from "antd"
import { Icon } from "ui/Icon"

export const InfoTooltip = ({ title }) => {
  return (
    <Tooltip title={title} placement="bottom">
      <Icon type="feather" name="Info" width={20} height={20} />
    </Tooltip>
  )
}
